var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center"},[_c('span',{staticClass:"font-medium tracking-wide font-mono"},[_vm._v(_vm._s(_vm.timer.displayTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }